<template>
  <section id="Password">
    <div
      v-if="valuetime && stringtime"
      class="form-group pl-lg-4"
    >
      <div v-if="$parent.last_password == ''">
        <label>{{ $t("You have not set your password.") }}</label>
        <div class="form-control-plaintext">
          <button
            class="btn btn-primary"
            data-toggle="modal"
            data-target="#ModalNewPassword"
          >
            {{ $t("Set Password") }}
          </button>
        </div>
      </div>
      <div v-else>
        <label>{{ $t("You last changed your password at") + ' ' + valuetime + ' ' + $t(stringtime) + ' ' + $t("ago") }}</label>
        <div class="form-control-plaintext">
          <button
            class="btn btn-primary"
            data-toggle="modal"
            data-target="#ModalChangePassword"
          >
            {{ $t("Change your password") }}
          </button>
        </div>
      </div>
    </div>
    <div v-else>
      <placeholder-content is-load="true" />
    </div>
  </section>
</template>
<script>
import PlaceholderContent from '@/plugins/PlaceholderContent.vue'
import { convertTimezone } from "@/common/tenancy/convertTimezone";
export default {
    components: {
        PlaceholderContent,
    },
    props: {
        valuetime: {
            type: [String, Number],
            default: '',
        },
        stringtime: {
            type: [String, Number],
            default: '',
        }
    },
    data() {
        return {
        }
    },
    methods: {
        convertTimezone(date){
            return convertTimezone.utcToLocal(date);
        }
    },
    mounted() {
    }
}
</script>



// WEBPACK FOOTER //
// src/components/central/account/security/Password.vue